/* MKE Ramadan-Kalender: Gebetszeiten-Rechenkern (eigene Berechnung nach MWL).
   Fadschr 18°, Ischaa 17°, Asr eine Schattenlänge (Schafiʿi), Sonnenrand am
   Horizont mit Höhe des Ortes, ±2 Minuten Sicherheitsmarge, gerundet immer in
   die sichere Richtung. "Sehri bis" = 19°-Zeit mit derselben Marge.
   Abgeglichen mit dem Python-Rechenkern (engine.py), gleiche Ergebnisse. */
(function(){
var R=Math.PI/180, D=180/Math.PI;
function jd(y,m,d){if(m<=2){y-=1;m+=12;}var a=Math.floor(y/100),b=2-a+Math.floor(a/4);
  return Math.floor(365.25*(y+4716))+Math.floor(30.6001*(m+1))+d+b-1524.5;}
function mod(a,n){return a-n*Math.floor(a/n);}
function sunAt(j){
  var T=(j-2451545.0)/36525.0;
  var L0=mod(280.46646+T*(36000.76983+T*0.0003032),360);
  var M=357.52911+T*(35999.05029-0.0001537*T);
  var e=0.016708634-T*(0.000042037+0.0000001267*T);
  var Mr=M*R;
  var C=Math.sin(Mr)*(1.914602-T*(0.004817+0.000014*T))+Math.sin(2*Mr)*(0.019993-0.000101*T)+Math.sin(3*Mr)*0.000289;
  var om=125.04-1934.136*T;
  var app=L0+C-0.00569-0.00478*Math.sin(om*R);
  var eps0=23+(26+((21.448-T*(46.815+T*(0.00059-T*0.001813))))/60)/60;
  var eps=eps0+0.00256*Math.cos(om*R);
  var decl=Math.asin(Math.sin(eps*R)*Math.sin(app*R))*D;
  var y=Math.pow(Math.tan(eps/2*R),2), L=L0*R;
  var Eq=4*D*(y*Math.sin(2*L)-2*e*Math.sin(Mr)+4*e*y*Math.sin(Mr)*Math.cos(2*L)-0.5*y*y*Math.sin(4*L)-1.25*e*e*Math.sin(2*Mr));
  return [decl,Eq];
}
function hourAngle(lat,decl,alt){
  var c=(Math.sin(alt*R)-Math.sin(lat*R)*Math.sin(decl*R))/(Math.cos(lat*R)*Math.cos(decl*R));
  if(c<-1||c>1) return null; return Math.acos(c)*D;
}
function raw(lat,lon,y,mo,d,tz,h){
  var j0=jd(y,mo,d), it=5, sunAlt=-(0.833+0.0347*Math.sqrt(Math.max(h,0)));
  var t=720.0,i;
  for(i=0;i<it;i++){t=720-4*lon-sunAt(j0+(t-tz*60)/1440.0)[1]+tz*60;}
  var n0=t, out={dhuhr:n0+0.336/15*60};
  function solve(alt,before){
    var t=n0+(before?-360:360)/6;
    for(var k=0;k<it;k++){var s=sunAt(j0+(t-tz*60)/1440.0),nn=720-4*lon-s[1]+tz*60,H=hourAngle(lat,s[0],alt);
      if(H===null) return null; t=before?nn-4*H:nn+4*H;}
    return t;
  }
  out.sunrise=solve(sunAlt,true); out.maghrib=solve(sunAlt,false);
  out.fajr=solve(-18,true); out.isha=solve(-17,false); out.sehri=solve(-19,true);
  t=n0+180;
  for(i=0;i<it;i++){var s=sunAt(j0+(t-tz*60)/1440.0),nn=720-4*lon-s[1]+tz*60,dr=s[0];
    var alt=Math.atan(1.0/(1.0+Math.tan(Math.abs(lat-dr)*R)))*D,H=hourAngle(lat,s[0],alt);
    if(H===null){out.asr=null;return out;} t=nn+4*H;}
  out.asr=t;
  return out;
}
var SEC={sehri:-2,fajr:-2,sunrise:-2,dhuhr:2,asr:2,maghrib:2,isha:2};
var BIAS={sehri:-0.254,fajr:-0.254,sunrise:-0.105,dhuhr:0.01,asr:0.366,maghrib:0.102,isha:-0.392};
/* Zusatz-Vorsicht 06.10.2026: Restabweichungen nur in sichere Richtung. */
var SAFE={sehri:0.05,fajr:0.05,sunrise:0.18,dhuhr:0.07,asr:0.05,maghrib:0.15,isha:0.22};
function pad(n){return (n<10?"0":"")+n;}
function times(lat,lon,h,y,mo,d,tz){
  var r=raw(lat,lon,y,mo,d,tz,h),o={};
  for(var k in SEC){var v=r[k];if(v==null){o[k]=null;continue;}
    v=v-BIAS[k]+SEC[k]+(SEC[k]>0?SAFE[k]:-SAFE[k]);var m=SEC[k]<0?Math.floor(v):Math.ceil(v);
    o[k]=pad(mod(Math.floor(m/60),24))+":"+pad(mod(m,60));}
  return o;
}
/* Ramadan 2027: 8. Februar bis 9. März, komplett Winterzeit (MEZ, tz=1). */
function ramadan2027(city){
  var out=[],start=new Date(2027,1,8);
  for(var i=0;i<30;i++){var dt=new Date(2027,1,8+i);
    var t=times(city.lat,city.lon,city.hoehe||0,dt.getFullYear(),dt.getMonth()+1,dt.getDate(),1);
    out.push({date:dt,sehri19:t.sehri,fajrMwl:t.fajr,shuruq:t.sunrise,dhuhr:t.dhuhr,asr:t.asr,maghrib:t.maghrib,isha:t.isha});}
  return out;
}
var api={times:times,ramadan2027:ramadan2027};
if(typeof window!=="undefined") window.MKE_ZEITEN=api;
if(typeof module!=="undefined") module.exports=api;
})();
